import React, { useEffect, useState, useRef } from "react";
import { Card, Button, TextField, Box, palette } from "@material-ui/core";
import { useStyles } from "../../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
    applicationListAction, updateApplicationAction, storeRelayAction, updateRelayByRouteAction, getApplicationAction, ConfigApplicaitonTemplate
    , Config, relayListAction, updateRelayAction, ListUsersByRole
} from "../../../redux/actions/ApplicationActions";
/* from application List */
import { LoadApplicationTemplate, ApplicationStoreAction } from '../../../redux/actions/CustomerAction';
/* end of application List */
import SimpleMenu from "../../../components/layouts/Navigation";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import SearchBar from "material-ui-search-bar";
import { useHistory, Link } from "react-router-dom";
import {
    createStyles,
    Theme,
    withStyles,
    WithStyles,
} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import logo from "../../../logo.png";
import * as ActionTypes from "../../../redux/ActionTypes";
import PhoneInput from 'react-phone-input-2';
import Geographical from "../../../constants/Geographical.json";
import 'react-phone-input-2/lib/material.css';
import parse from 'html-react-parser';
import AuthorizationErrorComponent from '../../AuthorizationErrorComponent';
import ErrorComponent from '../../ErrorComponent';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
/* from Application List */
import ApplicationTemplateEdit from "../../../components/partials/ApplicationTemplate/ApplicationTemplateEdit";
import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';
import CustomImage from '../../ImagesComponent';
import { FaEnvelopeSquare, FaSleigh } from "react-icons/fa";
import { DropzoneArea } from "material-ui-dropzone";
/* end of Application List */
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
        searchBox: {
            marginBottom: "15px"
        },
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
export default function Message(props) {
    const focusDiv = useRef();
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    const applicationsListResponse = useSelector((state) => state.applicationsInfo.applicationsList);
    const response = useSelector((state) => state.applicationsInfo.response);
    const [applicationTypes, setApplicationTypes] = useState([]);
    const [loading,setLoading] = useState(false);
    const [searched, setSearched] = useState("");
    const [rows, setRows] = useState([]);
    const [searchKey, setSearchKey] = useState("application_id");
    const [searchKeyValue, setSearchKeyValue] = useState("");
    const [userRoles, setUserRoles] = useState([]);
    const [relayStatus, setRelayStatus] = useState([]);
    const [applicationTypeKey, setApplicationTypeKey] = React.useState("all");
    const [applicationTypeKeyAssist, setApplicationTypeKeyAssist] = React.useState("all");
    const [restrictedStatus, setRestrictedStatus] = useState(false);
    const [restrictedResponse, setRestrictedResponse] = useState("");
    const [bodyStatus, setBodyStatus] = useState(false);
    const [applications, setApplications] = useState(false);
    const [tableConfig, setTableConnfig] = useState({
        total: 0,
        per_page: 10,
    });
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [open, setOpen] = React.useState(false);
    const [assignOpen, setAssignOpen] = React.useState(false);
    const [editable, setEditable] = useState(true);
    const [applicationName, setApplicationName] = useState("");
    const [userByRole, setUserByRole] = useState([]);
    const [btnReceiveDialog, setBtnReceiveDialog] = useState(false);
    const [mounted, setMounted] = useState(true);
    const [files, setFiles] = useState([]);
    const [filesInfo, setFilesInfo] = useState([]);
    const [btnStatusDisabled, setBtnStatusDisabled] = useState(false)
    const [docs, setDocs] = useState(false);
    const [messageTitle, setMessageTitle] = useState("List of Tippani")
    const [columns,setColumns] = useState([]);

    const [fields, setState] = useState({
        receiver_id: "",
        application_id:"",
        sender_id: "",
        message: "",
        comment: "",
        relay_time: "",
        relay_date:"",
        created_by_id: "",
        relay_status: "pending",
        receive_note:"Yes, I have received it.",
        action_status:"",
        application_status:"",
        file: [],


    });
    const defaultFieldsAssignment = {
        receiver_id: "",
        application_id: "",
        sender_id: "",
        message: "",
        comment: "",
        relay_time: "",
        relay_date: "",
        created_by_id: "",
        relay_status: "pending",
        receive_note: "Yes, I have received it.",
        action_status: "",
        application_status: "",
        role_user: '',
        changeStatus:false,
        users_by_role: [],
        file: [],

    }

    
    const [fieldsAssignment, setFieldsAssignment] = useState(defaultFieldsAssignment);
    /*clone from ApplicationList */
    const defaultValuesLicensePOE = {
        status: false,

    };
    const defaultAssignmentError = {
        relay_status: {
            name:'relay_status',
            status: false,
            message: "Please select status of assignment",
        },
        role_user: {
            name: 'role_user',
            status: false,
            message: "Please select role of staff or client",
        },
        receiver_id: {
            name: 'receiver_id',
            status: false,
            message: "Please Assgin any user",
        },
        message: {
            name: 'message',
            status: false,
            message: "Please write down any message",
        },
        comment: {
            name: 'comment',
            status: false,
            message: "Please write down any comment",
        },
        file:{
            name:"file",
            status:false,
            message:"you may attach the tippani herewith"
        }

    }
    const [assignmentError, setAssignmentError] = useState(defaultAssignmentError);
    const [formValuesLicensePOE, setFormValuesLicensePOE] = useState(defaultValuesLicensePOE);

    const [template, setTemplate] = useState(0);
    const [status, setStatus] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [configItem, setConfigItem] = useState(''); // for template selection
    const [hydroItem, setHydroItem] = useState(''); // for template selection
    const [dropZoneValue, setDropZoneValue] = useState({});
    const [result, setResult] = useState([]);
    const [flagger, setFlagger] = useState(true);
    const [assignButton, setAssignButton] = useState(false);
    const [modifyButton, setModifyButton] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [deletedFiles, setDeletedFiles] = useState([]);
    const [accessRestriction, setAccessRestriction] = useState(false);
    const [applicationAccessResponse, setApplicationAccessResponse] = useState('');
    const [applicationResponse, setApplicationResponse] = useState('');
    /*end of clone from ApplicationList */
    
    const labelList = {
        receiver_id:'Receiver',
        application_id: "Application",
        sender_id: "Sender",
        message: "Message",
        comment: "Comment",
        relay_time: "Sent Time",
        relay_date: "Sent Date",
        created_by_id: "Created By",
        relay_status: "Status",
    };
    const columnsA = [
        { field: "id", headerName: "Reference Number", width: 100, cellClassName: "cell_class_name" },

        { field: "application_id", headerName: "Application", width: 190, cellClassName: "cell_class_name" },
        { field: "sender_id", headerName: "Sender", width: 130, cellClassName: "cell_class_name" },
        { field: "receiver_id", headerName: "Receiver", width: 190, cellClassName: "cell_class_name" },

        { field: "comment", headerName: "Comment", width: 130, cellClassName: "cell_class_name" },
        { field: "message", headerName: "Message", width: 130, cellClassName: "cell_class_name" },
        { field: "relay_time", headerName: "Relay Time", width: 130, cellClassName: "cell_class_name" },
        { field: "relay_date", headerName: "Relay Date", width: 130, cellClassName: "cell_class_name" },
        // { field: "created_by_id", headerName: "Created By", width: 130 },
        { field: "relay_status", headerName: "Relay Status", width: 130 },
        { field: "actions", headerName: "Actions", width: 130 },

    ];
    const columnsB = [
        { field: "id", headerName: "Reference Number", width: 100, cellClassName: "cell_class_name" },

        { field: "application_id", headerName: "Application", width: 190, cellClassName: "cell_class_name" },
        { field: "sender_id", headerName: "Sender", width: 130, cellClassName: "cell_class_name" },
        { field: "receiver_id", headerName: "Receiver", width: 190, cellClassName: "cell_class_name" },

      
        { field: "relay_time", headerName: "Relay Time", width: 130, cellClassName: "cell_class_name" },
        { field: "relay_date", headerName: "Relay Date", width: 130, cellClassName: "cell_class_name" },
        // { field: "created_by_id", headerName: "Created By", width: 130 },
        { field: "relay_status", headerName: "Relay Status", width: 130 },
        { field: "actions", headerName: "Actions", width: 130 },

    ];
    const getDistrictName = (company) => {

        Geographical.map((option) => {
            if (option.id == company.company_province) {
                company.company_province = option.name;
                option.districts.map((district, index) => {
                    if (district.id == company.company_district) {

                        company.company_district = district.name;
                        district.municipalities.map((city, key) => {
                            if (city.id == company.company_city) {
                                company.company_city = city.name
                                city.wards.map((ward, key) => {
                                    if (ward == company.company_ward) {
                                        company.company_ward = ward;
                                    }

                                }) /*ward mapping not needed just done for fun */
                            }
                        })
                    }
                })
            }
        })
        // company.company_province = company.company_province + '<br/>' + company.company_district + '<br/>' + company.company_city + '<br/>' + company.company_ward
        return company;
    } 

    const assignUser = (event, row,userByRole) => {
        setEditFlag(false);
        setEditable(true);
       setFieldsAssignment({...fieldsAssignment,
           application_id: row.applications.id,
            fieldStatus:false,
            creator: row.applications.client.id,
            is_assigned:1,
            relay_current_id: row.id,
            relay_status: row.relay_status != null ? row.relay_status : "completed",
            changeStatus:false,
            
        })
        setApplicationTypeKey(row.relay_status != null ? row.relay_status : "completed");

        setAssignOpen(true);
    }

    const editRelay = (event, row, userByRole) => {
        setFieldsAssignment({
            ...fieldsAssignment,
            application_id: row.applications.id,
            fieldStatus: false,
            creator: row.applications.client.id,
            is_assigned: 1,
            id:row.id,
            relay_current_id: row.id,
            sender_id: row.sender.id,
            receiver_id: row.receiver.id,
            message: row.message,
            comment: row.comment,
            filesInfo:row.file_info,
            file: row.file,
            role_user: row.receiver.role_users_id,
            relay_status: row.relay_status != null ? row.relay_status : "completed",

        });
        setFilesInfo(row.file_info);
        setEditFlag(true);
        setEditable(true);
        setFiles(row.file);
        /* for fill up */
        let temp_obj = {
            ...fieldsAssignment,
            application_id: row.applications.id,
            fieldStatus: false,
            creator: row.applications.client.id,
            is_assigned: 1,
            id:row.id,
            sender_id: row.sender.id,
            receiver_id: row.receiver.id,
            message: row.message,
            comment: row.comment,
            relay_current_id:row.id,
            role_user: row.receiver.role_users_id,
            relay_status: row.relay_status != null ? row.relay_status : "completed",

        };
        setApplicationTypeKey(row.relay_status != null ? row.relay_status : "completed");
        ListUsersByRole(row.receiver.role_users_id, temp_obj, fieldsAssignment, setFieldsAssignment);
        setAssignOpen(true);

    };
    const viewFiles = (event, row, userByRole) => {
        setFieldsAssignment({
            ...fieldsAssignment,
            application_id: row.applications.id,
            fieldStatus: false,
            creator: row.applications.client.id,
            is_assigned: 1,
            id: row.id,
            sender_id: row.sender.id,
            receiver_id: row.receiver.id,
            message: row.message,
            comment: row.comment,
            filesInfo: row.file_info,
            file: row.file,
            role_user: row.receiver.role_users_id,
            relay_status: row.relay_status != null ? row.relay_status : "completed",

        });
        setEditable(false)
        setFilesInfo(row.file_info);
        setEditFlag(false);
        setFiles(row.file);
        /* for fill up */
        let temp_obj = {
            ...fieldsAssignment,
            application_id: row.applications.id,
            fieldStatus: false,
            creator: row.applications.client.id,
            is_assigned: 1,
            id: row.id,
            sender_id: row.sender.id,
            receiver_id: row.receiver.id,
            message: row.message,
            comment: row.comment,
            role_user: row.receiver.role_users_id,
            relay_status: row.relay_status != null ? row.relay_status : "completed",

        };
        setApplicationTypeKey(row.relay_status != null ? row.relay_status : "completed");
        ListUsersByRole(row.receiver.role_users_id, temp_obj, fieldsAssignment, setFieldsAssignment);
        setAssignOpen(true);

    };
    const deleteUser = (event, param) => {
        event.stopPropagation();
        //dispatch(CustomerDeleteAction(param.row, history));
    };
    const requestSearch = (searchedVal) => {

        applications.map((element) => (
            element.status = (element.status === null || element.status === 0) ? "Inactive" : "Active"

        ))
        applications.map((element) => (
            element = getDistrictName(element)
        ))
        setSearchKeyValue(searchedVal);
        setPage(0);
        


        dispatch(relayListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus,
            getDistrictName, setRows, setApplications, setTableConnfig, 0,
            page, rowsPerPage, applicationTypeKey, searchKey, searchedVal));
    };
    const handleSearchKey = (e) => {
        const { name, value } = e.target;
        setSearchKey(value);



    };
    const handleApplicationTypeKey = (e) => {
       
        const { name, value } = e.target;
        setApplicationTypeKey(value);
        setApplicationTypeKeyAssist(value);
        setPage(0);
        dispatch(relayListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus,
            getDistrictName, setRows, setApplications, setTableConnfig,
            0, 0, rowsPerPage, value, searchKey, searchKeyValue));


    };

    const handleAssignmentClose = () => {
        
        
        setDeletedFiles([]);
        setDropZoneValue([]);
        setCheckStatus(false);
        setEditFlag(false);
        setEditable(true);
        setFiles([]);
        setBtnStatusDisabled(false);
       dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });
        
        setState({
            ...fields,

            renderStatus: true,
        });
        setFieldsAssignment(defaultFieldsAssignment);
      
        setAssignOpen(false);
    }

    const handleClose = () => {
      
         
        setBtnStatusDisabled(false);
        setCheckStatus(false);
        setEditFlag(false)
        dispatch({ type: ActionTypes.FREE_USER_STATE, applicationsListResponse });
        setDeletedFiles([]);
        if (fields.changeStatus) {
            //to refresh the page 
            //dispatch(applicationListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, 0, 1, rowsPerPage, applicationTypeKey))
        }
        setState({
            ...fields,
            name: "",
            company_id: "",
            client_id: "",
            created_by_id: "",
            application_template_id: "",
            renderStatus: true,
            id: null,
            changeStatus: false,
            fieldStatus: false,
            renderStatus:true,
            status: false
        });
        setOpen(false);
    };
    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched);
    };

    /*Edit User Functionalities Section */

    const handleFieldChange = (e) => {
 
        setState({
            ...fields,
            changeStatus: true,

            fieldStatus: false,
            [e.target.name]: e.target.value,
        });
    };
   


    const handleFieldChangePhone = (value) => {
        
        if (fields['contact_no'] != value) {
           
            setState({
                ...fields, changeStatus: true,
                fieldStatus: false,
                'contact_no': value,
            })
        }
    }
    const handleFieldChangeForAssign = (e) => {
        setFieldsAssignment({ ...fieldsAssignment, [e.target.name]: e.target.value, fieldStatus: false, changeStatus:true})
        if (e.target.value ==""){
            setAssignmentError({
                ...assignmentError, [e.target.name]: {
                    ...assignmentError[e.target.name],
                    status: true
                }
            });
        }else{
            setAssignmentError({
                ...assignmentError, [e.target.name]: {
                    ...assignmentError[e.target.name],
                    status: false
                }
            });
        }
       

        setState({
            ...fields,
            renderStatus: false,
        });



    };
    const handleFieldChangeForRole = (e) => {
        setFieldsAssignment({ ...fieldsAssignment, [e.target.name]:e.target.value,fieldStatus:false})
        if (e.target.name == "role_user"){
           
            if (e.target.value == ""){
                setAssignmentError({
                    ...assignmentError, [e.target.name]: {
                        ...assignmentError[e.target.name],
                        status: true
                    }
                });

            }else{
                setAssignmentError({
                    ...assignmentError, receiver_id: {
                        ...assignmentError.receiver_id,
                        status: false
                    }, [e.target.name]: {
                        ...assignmentError[e.target.name],
                        status: false
                    }
                });
            }

        }
        else{
            if (e.target.value == "") {
                setAssignmentError({
                    ...assignmentError, [e.target.name]: {
                        ...assignmentError[e.target.name],
                        status: true
                    }
                });

            } else {
                setAssignmentError({
                    ...assignmentError, [e.target.name]: {
                        ...assignmentError[e.target.name],
                        status: false
                    }
                });
            }
        }
      
       
        ListUsersByRole(e.target.value, fieldsAssignment, fieldsAssignment, setFieldsAssignment)
    
      
        
        

    }
    const handleInputChangeDropzone = (e) => {
        setDropZoneValue(e)

        setState({
            ...fields, changeStatus: true,

        })
        setMounted(!mounted)
    };
  
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        dispatch(relayListAction(setRestrictedResponse, setRestrictedStatus,
            setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig,
            0, newPage, rowsPerPage, applicationTypeKey, searchKey, searchKeyValue));
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        dispatch(relayListAction(setRestrictedResponse, setRestrictedStatus, setBodyStatus, getDistrictName, setRows, setApplications, setTableConnfig, 0, 0, event.target.value, applicationTypeKey, searchKey, searchKeyValue));
    };

    /*End of Edit User Functionalities Section */
   /*function useful for message */

    const receiveRelay = (event, row, userByRole) => {
        setBtnReceiveDialog(false)
        setState({
            ...fields,
            application_id: row.applications.name,
            sender_id: row.sender.name,
            receiver_id: row.receiver != null ? row.receiver.name : userByRole.name,
            id: row.id,
            renderStatus: false,
            receive_note: row.receive_note != null ? fields.receive_note:fields.receive_note,
            relay_status: row.relay_status != null ? ((row.relay_status == "pending")?"processing":row.relay_status) : "accepted",
            action_status: row.action_status,
            is_assigned:0
        });
      
       


        setOpen(true);
    };
    const updateRelayActionStatus = (e) => {
        //alert(JSON.stringify(fields))
        e.preventDefault();
        setBtnReceiveDialog(true)

        let temp_object = {
            ...fields,
            changeStatus: true, // for backend update control and refersh if needed
        };


        dispatch(updateRelayAction(temp_object, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications));
       
        setState({
            ...fields,
            fieldStatus: true, // for message display
            status: 'processing'
        });



    }


    const createRelaySubmit = (e) =>{
        
        setFieldsAssignment({ ...fieldsAssignment, fieldStatus: true })
        e.preventDefault();
        let temp_error = {};
        let error_found  =false;
        for (var itemKey in assignmentError) {
            if (assignmentError.hasOwnProperty(itemKey) && itemKey!="file") { 
                
                if (fieldsAssignment[itemKey]==''){
                    temp_error = {...temp_error,
                        [itemKey]:{
                            name:assignmentError[itemKey].name,
                            status:true,
                            message: assignmentError[itemKey].message
                        }
                    }
                    error_found = true;

                    // })
                }else{
                    temp_error = {
                        ...temp_error,
                        [itemKey]: {
                            name: assignmentError[itemKey].name,
                            status: false,
                            message: assignmentError[itemKey].message
                        }
                    }
                }
              
            }
        }
       
        setAssignmentError(temp_error);
        if(error_found==true){
            //disable submit 
            return true;
        }
        setBtnStatusDisabled(true);
        e.preventDefault();
        const uploadData = new FormData();

        // Update the formData object
        Array.from(dropZoneValue).forEach((image_file) => {
            uploadData.append('file[]', image_file);
        });

        deletedFiles.forEach((file) => {
            uploadData.append('deletedFiles[]', parseInt(file));
        });
        uploadData.append('receiver_id', fieldsAssignment.receiver_id)

        uploadData.append('application_id', fieldsAssignment.application_id)
        uploadData.append('sender_id', fieldsAssignment.sender_id)
        uploadData.append('message', fieldsAssignment.message)
        uploadData.append('comment', fieldsAssignment.comment)
        uploadData.append('created_by_id', fieldsAssignment.created_by_id)
        uploadData.append('relay_status', fieldsAssignment.relay_status)
        uploadData.append('status', fieldsAssignment.status)
        uploadData.append('fieldStatus', fieldsAssignment.fieldStatus)
        uploadData.append('creator', fieldsAssignment.creator)
        uploadData.append('is_assigned', fieldsAssignment.is_assigned)

        uploadData.append('changeStatus', fieldsAssignment.changeStatus)
        uploadData.append('relay_current_id', fieldsAssignment.relay_current_id)
        



       
    
        if(fieldsAssignment.hasOwnProperty('id')){
        
       
       
         

            dispatch(updateRelayByRouteAction(uploadData, fieldsAssignment, setFieldsAssignment, fields, setState, setApplicationResponse, setBtnStatusDisabled));
            

     
            
           
            //ListUsersByRole(fieldsAssignment.role_user, uploadData, fieldsAssignment, setFieldsAssignment);
            

      } else{

        
       


       
            const uploadData = new FormData();

            // Update the formData object
            Array.from(dropZoneValue).forEach((image_file) => {
                uploadData.append('file[]', image_file);
            });

            deletedFiles.forEach((file) => {
                uploadData.append('deletedFiles[]', parseInt(file));
            });
            uploadData.append('receiver_id', fieldsAssignment.receiver_id)

            uploadData.append('application_id', fieldsAssignment.application_id)
            uploadData.append('sender_id', fieldsAssignment.sender_id)
            uploadData.append('message', fieldsAssignment.message)
            uploadData.append('comment', fieldsAssignment.comment)
            uploadData.append('created_by_id', fieldsAssignment.created_by_id)
            uploadData.append('relay_status', fieldsAssignment.relay_status)
            uploadData.append('status', fieldsAssignment.status)
            uploadData.append('fieldStatus', fieldsAssignment.fieldStatus)
            uploadData.append('creator', fieldsAssignment.creator)
            uploadData.append('is_assigned', fieldsAssignment.is_assigned)
            uploadData.append('changeStatus', fieldsAssignment.changeStatus)
            uploadData.append('relay_current_id', fieldsAssignment.relay_current_id)
            uploadData.append('id', fieldsAssignment.id)


            
         
            dispatch(storeRelayAction(uploadData,setRows, setApplications, fields, setState, setApplicationResponse,setBtnStatusDisabled));
       
       



      }

      
    }
    const enableEdit = (event) => {
        setEditFlag(!editFlag);
    }
    const cancelEdit = (event) => {
        setEditFlag(!editFlag);
        // setFormValuesCompany(originalCompanyData);
        // setDeletedFiles([]);
        // setDropZoneValue(defaultDropZone)
    }
    useEffect(() => {
         setLoading(true);
        
        Config().then(res => {

            setUserRoles(res.roles);
            setRelayStatus(res.relay_status);
            setUserByRole(res.user)
            if (res.user.role_users_id == 6 || res.user.role_users_id == 9){
                setFieldsAssignment({ ...fieldsAssignment, message: "Proceed with necessary action.", comment:"Proceed with necessary action."})
            }else if (res.user.role_users_id != 3 || res.user.role_users_id != 4) {
                setFieldsAssignment({ ...fieldsAssignment, message: "Please,have a look.", comment: "I don't have any comment." })
            }
            if (res.user.role_users_id == 3 || res.user.role_users_id == 4) { 
                setMessageTitle("Application Status");
                setColumns(columnsB)
            }else{
                setColumns(columnsA)
            }    
            dispatch(relayListAction(setRestrictedResponse, setRestrictedStatus, getDistrictName, setBodyStatus, setRows, setApplications, setTableConnfig, 0, page, rowsPerPage, applicationTypeKey));
            if (res.user.role_users_id != 3 && res.user.role_users_id != 4) {
                setDocs(true)
            }
        }).finally(()=>{
            setLoading(false)
        });

       

        return () => { };
    }, [fields.renderStatus == true]);

    return (
        <>
            <div className={classes.root}>
                {loading && <Grid container className={classes.bodyWrapper} style={{ position: "absolute", top: "30%", left: "50%", transform: 'translate("-50%","-50%")', fontSize: "24px" }}><span >Loading .....</span></Grid>}
                {!loading &&

                    <>
                {accessRestriction && <Grid container item xs={12}>
                    <Grid item xs={12}>
                        {applicationAccessResponse != "" && < ErrorComponent error={applicationAccessResponse.message} />}

                    </Grid>
                </Grid>}
                {restrictedStatus &&
                    <> <Grid container className={classes.bodyWrapper}>
                        <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

                        </Grid>
                    </Grid>
                    </>
                }


                {!restrictedStatus && bodyStatus &&
                    <Grid container className={classes.bodyWrapper}>

                        <Grid item xs={2}>
                            <Paper className={classes.paper}>

                            </Paper>
                        </Grid>

                        <Grid xs={9} md={10} className={classes.rightSideContent} style={{ marginTop: "25px" }}>
                                <Typography variant="h6" component="div" style={{ position: "relative", textAlign: "left", marginBottom: "15px" }} gutterBottom>
                                {messageTitle}
                            </Typography>
                            <Grid container item xs={10} style={{ marginBottom: "10px" }}>
                                    <Grid item xs={12} md={3} className={classes.searchBox}>

                                    <SearchBar
                                        value={searched}
                                        onChange={(searchVal) => requestSearch(searchVal)}
                                        onCancelSearch={() => cancelSearch()}
                                    />
                                </Grid>
                                <Grid item xs={3} style={{"display":"none"}}>
                                        <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                                        <InputLabel>Search Field</InputLabel>
                                        <Select
                                            name="search_key"
                                            label={"Search Type"}
                                            value={searchKey}
                                            onChange={handleSearchKey}

                                        >

                                            {Object.keys(labelList).map((key) => (
                                                <MenuItem key={key} value={key}>
                                                    {labelList[key]}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                    <Grid item xs={12} md={3}>
                                        <FormControl variant="outlined" className={[classes.formControl, classes.fullWidthMobile]}>

                                        <InputLabel>Tippani Status</InputLabel>
                                        <Select
                                            name="search_application_type"
                                            label={"Search Type"}
                                            value={applicationTypeKey}
                                            onChange={handleApplicationTypeKey}

                                        > <MenuItem key="all" value="all" xyz="all">
                                                All
                                            </MenuItem>

                                            {relayStatus!=undefined && relayStatus.map((item) => {

                                                return <MenuItem key={item} value={item} xyz={item}>
                                                    {item}
                                                </MenuItem>
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>


                            </Grid>
                            <Grid container item xs={10}>
                                <Grid xs={12}>
                                    <div className={classes.MuiDataGrid_windowContainer}>

                                        {applications.length !== 0 ? (
                                            <>
                                                <TableContainer className={classes.container}>
                                                    <Table stickyHeader aria-label="sticky table">
                                                        <TableHead>
                                                            <TableRow>
                                                                {columns.map((column) => {
                                                                   
                                                                    if (column.field.localeCompare("actions")) {
                                                                       
                                                                        return (<TableCell
                                                                            key={column.id}
                                                                            align={column.align}
                                                                            style={{ minWidth: column.minWidth }}
                                                                        >
                                                                            {column.headerName}
                                                                        </TableCell>)
                                                                    } else {
                                                                        if (userByRole.role_users_id == 3 || userByRole.role_users_id == 4) {
                                                                            return "";
                                                                        }else{

                                                                        return (<TableCell
                                                                            key={column.id}
                                                                            align={column.align}
                                                                            style={{ minWidth: column.minWidth }}
                                                                        >
                                                                            {column.headerName}
                                                                        </TableCell>)
                                                                    }
                                                                   }
                                                                })
                                                                }

                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {rows.map((row, index) => {
                                                                return (
                                                                    <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                                        {columns.map((column) => {
                                                                            const value = row[column.field];
                                                                            
                                                                            if (column.field == "actions") {
                                                                                if (userByRole.role_users_id == 3 || userByRole.role_users_id == 4) {
                                                                                    return "";
                                                                                } else {
                                                                                return (<TableCell key={column.field}>
                                                                                   
                                                                                    <div
                                                                                        style={{
                                                                                            textAlign: "center",
                                                                                            paddingLeft: "15px",
                                                                                            paddingRight: "15px",
                                                                                        }}
                                                                                        key={column.field}
                                                                                    > 
                                                                                    <> 
                                                                                            {row.sender.id == userByRole.id && row.receive_note == null && (row.relay_status != "completed" && row.relay_status != "cancelled" && row.relay_status != "intermediate") && 
                                                                                                <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                                                                   
                                                                                                    editRelay(event, row, userByRole);
                                                                                                }}>Route</Button></span>
                                                                                            }
                                                                                            {/* {(row.sender.id == userByRole.id || userByRole.role_users_id == 6 || userByRole.role_users_id == 8 || userByRole.role_users_id == 1) && (row.relay_status == "cancelled" || row.relay_status == "intermediate") &&
                                                                                                <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {

                                                                                                    editRelay(event, row, userByRole);
                                                                                                }}>Allow change</Button></span>
                                                                                            } */}
                                                                                            
                                                                                            {row.receiver != null  && (row.receive_note != null && row.receive_note.replace(/^\s+|\s+$/gm,'')!="") &&
                                                                                                <span style={{marginTop:"30px",marginBottom:"30px"}}><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "rgb(198 23 37)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                                                                    receiveRelay(event, row, userByRole);
                                                                                                }} disabled>Received</Button>
                                                                                                    <br />
                                                                                                    {row.receive_note}
                                                                                                    <br />
                                                                                                </span>
                                                                                            }
                                                                                            {row.receiver != null && row.receiver.id == userByRole.id && (row.receive_note != null && row.receive_note.replace(/^\s+|\s+$/gm, '') != "") && row.is_assigned==0 &&
                                                                                                <span style={{ marginTop: "30px", marginBottom: "30px" }}>
                                                                                                    <br /><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                                                                    assignUser(event, row,userByRole);
                                                                                                }}>Assign</Button>
                                                                                                    
                                                                                                </span>
                                                                                            }
                                                                                            {row.receiver == null && (userByRole.role_users_id == 6 || userByRole.role_users_id == 8 || userByRole.role_users_id == 1) && 
                                                                                                <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "rgb(15 104 167)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                                                                    receiveRelay(event, row, userByRole);
                                                                                                }}>Receive</Button></span>
                                                                                            }
                                                                                          
                                                                                            
                                                                                            {row.receiver != null && row.receiver.id == userByRole.id && (row.receive_note == null || row.receive_note.replace(/^\s+|\s+$/gm, '') == "") && 
                                                                                                <span><Button variant="outlined" size="large" color="success" style={{ backgroundColor: "rgb(15 104 167)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} onClick={(event) => {
                                                                                                    receiveRelay(event, row, userByRole);
                                                                                                }}>Receive</Button></span>
                                                                                            }
                                                                                           
                                                                                     
                                                                                        </>
           
                                                                                     
                                                                                        </div>

                                                                                </TableCell>)
                                                                                }
                                                                            } else if (column.field =="application_id"){
                                                                                return (<TableCell key={column.field} >
                                                                                     { value }
                                                                                    {docs && (userByRole.role_users_id != 3 && userByRole.role_users_id != 4) && !(row.receiver!=null && [3,4].includes(row.receiver.role_users_id)) && !(row.sender!=null && [3,4].includes(row.sender.role_users_id)) && <Button variant="outlined" size="large" color="success" style={{ backgroundColor: "#569919", color: "#fff", fontSize: "10px", marginBottom: "5px", marginTop: "10px" }} onClick={(event) => {
                                                                                        viewFiles(event, row, userByRole);
                                                                                        }}> Documents</Button>
                                                                                     }
                                                                                </TableCell>
                                                                                );
                                                                               
                                                                            }
                                                                            else {
                                                                                return (
                                                                                    <TableCell key={column.field} >
                                                                                        {row['status'] == "cancelled" && column.field == "status" && <span style={{ color: "red" }}>
                                                                                            <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(185 32 52)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                                                                Cancelled
                                                                                            </Button>
                                                                                        </span>}
                                                                                        {row['status'] == "draft" && column.field == "status"
                                                                                            &&
                                                                                            <span style={{ fontSize: "bold", color: "#000", fontSize: "14x" }}>
                                                                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(74 24 0)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                                                                    Draft</Button></span>
                                                                                        }
                                                                                        {row['status'] == "pending" && column.field == "status"
                                                                                            &&

                                                                                            <span style={{ fontSize: "bold", color: "#234206", fontSize: "14px" }}><Button variant="outlined" size="small" style={{ backgroundColor: "rgb(16 100 159)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                                                                Pending</Button></span>
                                                                                        }
                                                                                        {row['status'] == "processing" && column.field == "status" &&
                                                                                            <span style={{ fontSize: "bold", color: "#3f51b5", fontSize: "14px" }}>  <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(126 83 159)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                                                                In progress</Button></span>
                                                                                        }
                                                                                        {row['status'] == "completed" && column.field == "status" &&
                                                                                            <span style={{ fontSize: "bold", color: "#000", fontSize: "14px" }}>
                                                                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(78 143 20)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                                                                    Completed</Button></span>
                                                                                        }
                                                                                        {row['status'] == "intermediate" && column.field == "status" &&
                                                                                            <span style={{ fontSize: "bold", color: "#000", fontSize: "14px" }}>
                                                                                                <Button variant="outlined" size="small" style={{ backgroundColor: "rgb(153 167 38)", color: "#fff", fontSize: "10px", marginBottom: "5px" }} disabled>
                                                                                                    Intermediate</Button></span>
                                                                                        }
                                                                                        {column.field != "status" && value}

                                                                                    </TableCell>
                                                                                );
                                                                            }
                                                                        })}
                                                                        {



                                                                        }

                                                                    </TableRow>
                                                                );
                                                            })}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                                <TablePagination
                                                    rowsPerPageOptions={[10, 25, 100]}
                                                    component="div"
                                                    count={tableConfig.total}
                                                    rowsPerPage={tableConfig.per_page}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </>
                                        ) : (
                                            <div className={classes.beforeLoad}>


                                                <span>Displaying Tippanis List...</span>
                                                <br />
                                                {applicationsListResponse.success &&
                                                    applicationsListResponse.message


                                                }
                                            </div>
                                        )}
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid>
                                <Dialog
                                    onClose={handleClose}
                                    aria-labelledby="customized-dialog-title"
                                    open={open}
                                    fullWidth
                                    maxWidth="lg"
                                >
                                    <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                                        <b
                                            className={classes.primary}
                                            style={{ textAlign: "center" }}
                                        >
                                            Application Receive Note
                                            </b>
                                    </DialogTitle>


                                    <DialogContent dividers>
                                        {applicationsListResponse.success == false &&
                                            applicationsListResponse.user != "" &&
                                            fields.fieldStatus == true &&
                                            <div className={classes.customFail}>
                                                {applicationsListResponse.message}
                                            </div>

                                        }

                                        {
                                            applicationsListResponse.success == true &&
                                            applicationsListResponse.user != "" &&
                                            fields.fieldStatus == true &&
                                            <div className={classes.customSuccess}>
                                                {applicationsListResponse.message}
                                            </div>

                                        }

                                        {!accessRestriction && <Grid container item xs={12} >
                                            <Grid item xs={12} ref={focusDiv}>
                                                {applicationResponse != "" && applicationResponse.success == false && < ErrorComponent error={applicationResponse.message} />}

                                            </Grid>
                                        </Grid>}
                                        <form >
                                            <Grid container item xs={12}>
                                                <Grid item xs={12}>
                                                    <InputLabel style={{ marginBottom: "10px" }}>Receive Note</InputLabel>
                                                <FormControl variant="outlined" className={classes.formControl}>

                                                    <TextareaAutosize
                                                            id="receive_note"
                                                            name="receive_note"
                                                        label={"Receive Note"}
                                                        aria-label="minimum height"
                                                        minRows={10}
                                                        placeholder={"Receive Note"}
                                                        value={fields.receive_note && fields.receive_note.length === 0 ?"Yes, I have received it.": fields.receive_note}
                                                        onChange={handleFieldChange}
                                                        inputlabelprops={{
                                                            shrink: true,
                                                        }}
                                                        style={{ width: "100%" }}
                                                    />
                                                    <br />
                                                        {fields.receive_note == "" && <span style={{ color: "red" }}> Receive note must not be empty.</span>}
                                                </FormControl>
                                               
                                                   
                                                </Grid>
                                               
                                            </Grid>
                                          
                                                <DialogActions>
                                                <Button autoFocus onClick={updateRelayActionStatus} className={[classes.customButton].join(" ")}
                                                        orientation="vertical"
                                                        aria-label="vertical contained button group"
                                                        variant="contained"
                                                        color="primary"
                                                        style={{ clear: "both" }}
                                                        disabled={btnReceiveDialog}
                                                        >
                                                        Receive
                                                    </Button>
                                                </DialogActions>
                                           
                                        </form>
                                    </DialogContent>

                                </Dialog>


                                {/* Assignnment */}

                                <Dialog
                                    onClose={handleAssignmentClose}
                                    aria-labelledby="customized-dialog-title"
                                    open={assignOpen}
                                    fullWidth
                                    maxWidth="lg"
                                >
                                    <DialogTitle id="customized-dialog-title" onClose={handleAssignmentClose}>
                                        <b
                                            className={classes.primary}
                                            style={{ textAlign: "center" }}
                                        >
                                            Tippani
                                        </b>
                                    </DialogTitle>
                                    
                                   
                                    <DialogContent dividers>
                                        {response.success == false &&
                                            response.user != "" &&
                                            fieldsAssignment.fieldStatus == true &&
                                            <div className={classes.customFail}>
                                                {response.message}
                                            </div>

                                        }

                                        {
                                            response.success == true &&
                                            response.user != "" &&
                                            fieldsAssignment.fieldStatus == true &&
                                            <div className={classes.customSuccess}>
                                                    {response.message}
                                            </div>

                                        }
                                        <Grid container item xs={12}>
                                            {!editable && files != null && files.length != 0 &&
                                                files.map((option, index) => (

                                                    (deletedFiles.length && deletedFiles.includes(option)) ?
                                                        false
                                                        :
                                                        <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                                                            setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={filesInfo} />

                                                ))
                                            }
                                            </Grid>
                                        {editable &&
                                        <>
                                        <form >
                                            <Grid container item xs={12}>
                                                 <Typography variant="h6" component="div" gutterBottom style={{ color: "#0d0d0d", position: "relative" }}>
                                                    Tippani
                                                </Typography>
                                               
                                                <Grid container item xs={12} style={{ marginBottom: "25px" }}>
                                                    <Grid item xs={3}>
                                                        <FormControl variant="outlined" className={classes.formControl}>

                                                            <InputLabel>Comment Status</InputLabel>
                                                            <Select
                                                                name="relay_status"
                                                                label={"Search Type"}
                                                                value={fieldsAssignment.relay_status}
                                                                onChange={handleFieldChangeForAssign}

                                                            > <MenuItem key="all" value="all" xyz="all">
                                                                    All
                                                                </MenuItem>

                                                                {relayStatus != undefined && relayStatus.map((item) => {

                                                                    return <MenuItem key={item} value={item} xyz={item}>
                                                                        {item}
                                                                    </MenuItem>
                                                                })}
                                                            </Select>
                                                            <br/>
                                                            <br />
                                                            {assignmentError.relay_status.status == true && <span style={{ color: "red" }}>{assignmentError.relay_status.message}</span>}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <FormControl variant="outlined" className={classes.formControl}>

                                                            <InputLabel>Select Role</InputLabel>
                                                            <Select
                                                                name="role_user"
                                                                label={"Select Role"}
                                                                value={fieldsAssignment.role_user}
                                                                onChange={handleFieldChangeForRole}

                                                            >

                                                                {userRoles.map((item) => (
                                                                    <MenuItem key={item.id} value={item.id}>
                                                                        {item.name}
                                                                    </MenuItem>
                                                                ))}
                                                            </Select>
                                                            <br/>
                                                            {assignmentError.role_user.status == true && <span style={{ color: "red" }}>{assignmentError.role_user.message}</span>}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={3}>
                                                        <FormControl variant="outlined" className={classes.formControl}>

                                                            <InputLabel>Select User</InputLabel>
                                                            <Select
                                                                name="receiver_id"
                                                                label={"Select User"}
                                                                value={fieldsAssignment.receiver_id}
                                                                onChange={handleFieldChangeForAssign}

                                                            >
                                                                {/* {response!="" && response.success != false && response.data.length > 0 && response.data.map((item) => (
                                                                    <MenuItem key={item.id} value={item.id}>
                                                                        {item.first_name + " " + ((item.middle_name != null )?(item.middle_name + " "):"")+ item.last_name}
                                                                    </MenuItem>
                                                                ))} */}
                                                                {fieldsAssignment.users_by_role.length != 0 && fieldsAssignment.users_by_role.map((item) => (
                                                                    <MenuItem key={item.id} value={item.id}>
                                                                        {item.first_name + " " + ((item.middle_name != null) ? (item.middle_name + " ") : "") + item.last_name}
                                                                    </MenuItem>
                                                                ))}

                                                                
                                                            </Select>
                                                            <br/>
                                                            {assignmentError.receiver_id.status == true && <span style={{ color: "red" }}>{assignmentError.receiver_id.message}</span>}
                                                        </FormControl>
                                                    </Grid>



                                                </Grid>
                                             
                                                <Grid container item xs={12}>
                                                    <Grid item xs={12} md="6">
                                                        <InputLabel style={{ marginBottom: "10px" }}>Message</InputLabel>
                                                        <FormControl variant="outlined" className={classes.formControl}>

                                                            <TextareaAutosize
                                                                id="message"
                                                                name="message"
                                                                label={"Message"}
                                                                aria-label="minimum height"
                                                                minRows={10}
                                                                placeholder={"Message"}
                                                                value={fieldsAssignment.message}
                                                                onChange={handleFieldChangeForAssign}
                                                                inputlabelprops={{
                                                                    shrink: true,
                                                                }}
                                                                style={{ width: "100%" }}
                                                            />
                                                            <br />
                                                            {assignmentError.message.status == true && <span style={{ color: "red" }}>{assignmentError.message.message}</span>}
                                                        </FormControl>


                                                    </Grid> 
                                                     
                                                        <Grid item xs={12} md="6">
                                                            <InputLabel style={{ marginBottom: "10px" }}>Comment</InputLabel>
                                                            <FormControl variant="outlined" className={classes.formControl}>

                                                                <TextareaAutosize
                                                                id="comment"
                                                                name="comment"
                                                                label={"Comment"}
                                                                    aria-label="minimum height"
                                                                    minRows={10}
                                                                    placeholder={"Comment"}
                                                                value={fieldsAssignment.comment}
                                                                onChange={handleFieldChangeForAssign}
                                                                    inputlabelprops={{
                                                                        shrink: true,
                                                                    }}
                                                                    style={{ width: "100%" }}
                                                                />
                                                                <br />
                                                            {assignmentError.comment.status == true && <span style={{ color: "red" }}>{assignmentError.comment.message}</span>}
                                                         
                                                            </FormControl>


                                                        </Grid>
                                                   
                                                    <Grid
                                                        item
                                                        xs={12} container
                                                        style={{
                                                            marginTop: "15px",
                                                            padding: "25px",
                                                            border: "1px solid #ddd",
                                                        }}
                                                    >


                                                        
                                                        {!editable && files.length == 0 &&
                                                            <span>Any file has not been uploaded.</span>
                                                        }

                                                       
                                                            <>
                                                                <Typography
                                                                    variant="subtitle1"
                                                                    component="div"
                                                                    gutterBottom
                                                                    style={{ fontWeight: "bold", width: '100%' }}
                                                                >
                                                                    Tippani File
                                                                </Typography>
                                                                <Typography
                                                                    variant="caption"
                                                                    display="block"
                                                                    style={{ marginBottom: "10px" }}
                                                                    gutterBottom
                                                                >
                                                                    You can upload multiple files here
                                                                </Typography>

                                                            {files != null && files.length != 0 &&
                                                                files.map((option, index) => (

                                                                    (deletedFiles.length && deletedFiles.includes(option)) ?
                                                                        false
                                                                        :
                                                                        <CustomImage option={option} index={index} deletedFiles={deletedFiles}
                                                                            setDeletedFiles={setDeletedFiles} key={index} editFlag={editFlag} filesInfo={filesInfo} />

                                                                ))
                                                            }


                                                                <DropzoneArea
                                                                    acceptedFiles={[
                                                                        "image/*",
                                                                        "application/pdf",
                                                                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'

                                                                    ]}
                                                                    name="file"
                                                                    id="file"
                                                                    filesLimit={5}
                                                                    dropzoneText="Drop files here or click to upload."
                                                                    onChange={handleInputChangeDropzone}
                                                                    showPreviews={true}
                                                                    showPreviewsInDropzone={false}
                                                                    useChipsForPreview
                                                                    previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                                                                    previewChipProps={{ classes: { root: classes.previewChip } }}
                                                                    previewText="Selected files"
                                                                    maxFileSize={204800000000}
                                                                    multiple
                                                                    dropzoneParagraphClass={classes.dropzoneParagraphClass}

                                                                />
                                                            </>
                                                        
                                                    </Grid>

                                                </Grid>
                                                   
                                              
                                            </Grid>
                                         
                                        </form>
                                  
                                    <DialogActions>
                                        <Button autoFocus onClick={createRelaySubmit} className={[classes.customButton].join(" ")}
                                            orientation="vertical"
                                            aria-label="vertical contained button group"
                                            variant="contained"
                                            color="primary"
                                            disabled={btnStatusDisabled}
                                            style={{ clear: "both" }}>
                                            Submit
                                        </Button>
                                    </DialogActions>
                                      </>
                                    }
                                    </DialogContent>
                                </Dialog>



                            </Grid>
                        </Grid>
                    </Grid>
                }
                </>
                }
            </div>
        </>
    );
}
